<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14.001">
    <g transform="translate(0 0.001)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M495.755,5631.56a.809.809,0,0,1,.809-.81h2.428a.81.81,0,0,1,.809.81v2.428a.81.81,0,0,1-.809.81h-2.428a.809.809,0,0,1-.809-.81Z"
              transform="translate(-494.826 -5621.907)"/>
        <path d="M503.255,5616.56a.809.809,0,0,1,.809-.81h2.428a.81.81,0,0,1,.809.81v2.428a.81.81,0,0,1-.809.81h-2.428a.809.809,0,0,1-.809-.81Z"
              transform="translate(-498.279 -5615.001)"/>
        <path d="M510.755,5631.56a.809.809,0,0,1,.809-.81h2.428a.81.81,0,0,1,.809.81v2.428a.81.81,0,0,1-.809.81h-2.428a.809.809,0,0,1-.809-.81Z"
              transform="translate(-501.732 -5621.907)"/>
        <path d="M499.505,5629.369v-.81a.809.809,0,0,1,.809-.81h6.475a.81.81,0,0,1,.809.81v.81"
              transform="translate(-496.553 -5620.526)"/>
        <path d="M507.005,5623.25v2.428" transform="translate(-500.005 -5618.454)"/>
    </g>
</svg>
</template>